import { Component, Input } from '@angular/core';

@Component({
  selector: 'mz-navbar-item',
  template: `<li 
  class="{{ itemClass }}"
  [class.active]="active"
>
  <ng-content></ng-content>
</li>`,
  styles: [``],
})
export class MzNavbarItemComponent {
  @Input() active: boolean;
  @Input() itemClass: string;
}
